module.exports = __webpack_public_path__ + "img/1.4a4d942.png";